import { NAVIGATION_RECEIVE, NAVIGATION_MOBILE_OPEN } from '../Actions/Navigation.action';

export const navigation = (state = { menu:[] }, action) => {
    switch (action.type) {
        case NAVIGATION_MOBILE_OPEN:
            return {
                ...state,
                ...action.payload
            };
        case NAVIGATION_RECEIVE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}